import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  header: {
    fontWeight: 'bold',
    fontSize: '1.125rem',
    marginBottom: '8px',
  },
}));
